import * as types from '../mutation-types'
import api from '@/api/files'

// initial state
const state = {
    files: [],
    loaded: false,
}

const getters = {
    files: state => state.files,
    filesLoaded: state => state.loaded,
}

const actions = {
    getFiles({ commit }, payload) {
        commit(types.SET_FILES_LOADED, false );
        api.getCompanyFiles(payload,(response) => {
            commit(types.SET_FILES, response._embedded.FileCompany );
            commit(types.SET_FILES_LOADED, true );
        })
    },
    cleanFiles({commit}) {
        commit(types.SET_FILES_LOADED, false );
        commit(types.SET_FILES, {} );
    }
}

const mutations = {
    [types.SET_FILES] (state, solution ) {
        state.files = solution
    },
    [types.SET_FILES_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


